var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnaliticsStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 19,
    viewBox: "0 0 25 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_7218_36323)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5199 14.3451C18.5905 14.4047 20.3119 12.6214 20.3648 10.362C20.4178 8.10264 18.7822 6.22272 16.7117 6.16312C14.6412 6.10352 12.9198 7.88679 12.8668 10.1462C12.8139 12.4055 14.4494 14.2855 16.5199 14.3451ZM9.06111 9.86508C9.95963 9.89095 10.7067 9.11708 10.7296 8.13659C10.7526 7.15611 10.0429 6.3403 9.14433 6.31443C8.24581 6.28857 7.49878 7.06244 7.47579 8.04292C7.45281 9.02341 8.16258 9.83921 9.06111 9.86508ZM6.04268 4.73224C6.26767 5.15346 6.1373 5.69368 5.75148 5.93887C5.36566 6.18405 4.8705 6.04135 4.6455 5.62013C4.42051 5.19891 4.55088 4.65868 4.9367 4.4135C5.32252 4.16831 5.81768 4.31102 6.04268 4.73224Z",
    fill: "#89C6FB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_7218_36323",
    x: 0.535156,
    y: 0.293457,
    width: 23.8311,
    height: 18.053,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_7218_36323"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnaliticsStar);
export default __webpack_public_path__ + "static/media/AnaliticsStar.07dd23d44b0305ece92a10e2431c6e51.svg";
export { ForwardRef as ReactComponent };